import { theme } from '@frontend/theme';
import { Tabs } from '@frontend/design-system';
import { Container } from '../../components/container';
import { DevicesTable } from './devices-table';
import { UnifyDevices } from './unify';

export const Devices = () => {
  return (
    <main>
      <Container>
        <Tabs initialTab='devices'>
          <Tabs.Bar
            css={{
              background: theme.colors.white,
              width: 'fit-content',
              borderTopRightRadius: '8px',
              borderTopLeftRadius: '8px',

              '& button:hover:not(:disabled)': {
                background: theme.colors.neutral10,
              },
              '& button:focus': {
                background: theme.colors.white,
              },
            }}
          >
            <Tabs.Tab id='devices'>Devices</Tabs.Tab>
            <Tabs.Tab id='Unify'>Unify</Tabs.Tab>
            <Tabs.Tab id='deunify' disabled>
              Deunify
            </Tabs.Tab>
          </Tabs.Bar>
          <Tabs.Panel controller='devices'>
            <DevicesTable />
          </Tabs.Panel>
          <Tabs.Panel controller='Unify'>
            <UnifyDevices />
          </Tabs.Panel>
          <Tabs.Panel controller='deunify'>
            <></>
          </Tabs.Panel>
        </Tabs>
      </Container>
    </main>
  );
};
